module.exports = {
  label: '特殊货物信息',
  CLASSNO: '危险品货物类别 (CLASS NO)',
  UNNO: '联合国编号',
  PACKING: '货物包装类别',
  EMS: 'Emergency Schedule',
  Point: 'Flashpoint',
  Isolation: '隔离',
  man24: '24小时紧急联系人',
  tel24: '电话号码',
  ResponsibleParty: '责任方',
  HSCODE: 'HS编码',
  ContractNbr: '合同号',
  SHIPPER: '尺寸(长宽高)',
  PickTime: '提箱时间',
  SeaPullution: '海洋污染',
  GOH: '挂衣箱',
  Tier: '层',
  Hanger: '每层根数',
  Ropes: '每管几根绳',
  Knots: '每个绳几个节',
  ReformCost: '改制费用',
  Warehouse: '进仓仓库',
  Reefer: '冷藏箱',
  humidity: '湿度（%）',
  ventilation: '通风量（m3）',
  Business: '是否要商检',
  PTI: '预冷提前天数',
  ContainerYard: '进箱点',
  Address: '门点信息',
  StuffingTime: '装箱时间',
  DeliverTime: '送箱港区',
  WarehousingTime: '进仓日期',
  DoccutoffTime: '截单日期',
  CustomsCutoffTime: '截关日期',
  CorrectTransportName: '正确运输名称',
  SecondarySpecialGoods: '副危险类别',
  GrossWeight: '毛重',
  NeatWeight: '净重',
  OuterPackagingType: '外包装类型',
  OuterPackagingQuantity: '外包装件数',
  InnerPackagingType: '内包装类型',
  InnerPackagingQuantity: '内包装件数',
  Remark: '备注',
  Add: '新增',
  Delete: '删除',
  PackingCode: '包装代码',
  Import: '导入',
  FillIn: '关联',
  OnlyEnterYN: '只能输入Y或N',
  ThisFieldRequired: '如果外包装类型是4G，该栏位必填',
  HumidityToolTip: '湿度=空气中的湿度百分比',
  Temp: '温度',
  VentilationWse: '通风量',
  VgmWeight: 'VGM重',
  dgContactEmail: '危险品联系人邮箱',
  dgContactFax: '危险品联系人传真',
  bookingNo: '订舱运编号',
  TemperatureUnit: '温度单位'
}
